import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { useRoutes } from "react-router";
import Layout from "./pages/Layout.js";

import Terms from "./pages/Terms.js";
import Error from "./pages/Error.js";

import LandingPage from "./pages/LandingPage.js";
import AboutPage from "./pages/AboutPage.js";
import FaqPage from "./pages/FaqPage.js";
import ContactPage from "./pages/ContactPage.js";

function App() {
    let element = useRoutes([
        {
            path: "/",
            element: <Layout />,
            children: [
                { path: "/", element: <LandingPage /> },
                { path: "/about", element: <AboutPage /> },
                { path: "/faq", element: <FaqPage /> },
                { path: "/contact", element: <ContactPage /> },
                { path: "/terms", element: <Terms /> },
                { path: "*", element: <Error /> },
            ],
        },
    ]);

    return element;
}

export default App;
